import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import Input from "../Input";
import Label from "../Label";
import { debounce } from "lodash";
import Button from "../Button";

const CouponForm = ({ data, office, onChange = () => {}, onCoupon = () => {} }) => {

    const [coupon, setCoupon] = useState(null);
    const [errors, setErrors] = useState([]);
    const [isProcessingButtonGetCoupon, setIsProcessingButtonGetCoupon] = useState(false);

    const getCouponIdByCode = async (code, data) => {
        console.log({'getcouponidbycode': data})
        if (code) {
            try {
                const response = await axios.get(route('api.coupons.get-by-code', {code, office}));
                setCoupon(response.data?.coupon);
                onCoupon && onCoupon(response.data?.coupon, data);
                setErrors([]);
            } catch (error) {
                try {
                    setErrors(error.response.data?.errors || []);
                } catch (error) {
                    console.log(error)
                }
            }
        }
        setIsProcessingButtonGetCoupon(false);
    }

    const debouncedGetCouponIdByCode = useCallback(
        debounce(async (code, data) => {
            getCouponIdByCode(code, data);
        }, 600)
    , [])

    useEffect(() => {
        console.log({'couponcodeuseeffect': data})
        setIsProcessingButtonGetCoupon(true);
        debouncedGetCouponIdByCode(data.coupon_code, data)
    }, [data.coupon_code]);

    const handleClick = () => {
        console.log({'couponhandleclick': data})
        setIsProcessingButtonGetCoupon(true);
        getCouponIdByCode(data.coupon_code, data);
    }

    const handleChange = (event) => {
        console.log({'couponhandlechange': data})
        onChange && onChange(event.target.value);
        setErrors([]);
    }

    const handleCancel = () => {
        onChange && onChange('');

        setCoupon(null);
        onCoupon && onCoupon(null, data);
    }

    console.log({'couponform': data})

    return (
        <div className="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
            {coupon ? (
                <div>
                    <div className="flex justify-between items-center">
                        <div>
                            <h3 className="font-bold">{coupon.name}</h3>
                            <small>Cupón de descuento aplicado</small>
                        </div>
                        <svg className="cursor-pointer w-6 h-6" onClick={handleCancel} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
                    </div>
                    {/* <Button onClick={handleCancel} type="button">Cancelar</Button> */}
                </div>
            ) : (
                <>
                    <div className="mb-2">
                        <Label forInput="coupon_code" value="Cupón de descuento" />
                        <Input
                            type="text"
                            min="0"
                            name="coupon_code"
                            value={data.coupon_code}
                            className="mt-1 block w-full"
                            handleChange={handleChange}
                        />
                    </div>
                    <Button
                        onClick={handleClick}
                        type="button"
                        processing={isProcessingButtonGetCoupon}
                    >
                        Cobrar
                    </Button>
                </>
            )}
            <ul style={{ color: '#ff0000', marginTop: errors.length ? '1rem' : 0 }} className="list-disc ml-6">
                {errors.map(({ code, message }, index) => (
                    <li key={`coupon-error-${code}-${index}`}>
                        <small style={{ color: '#ff0000' }}>{message}</small>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default CouponForm